import { RouteObject } from 'react-router-dom';
import { lazy } from 'react';
import HomePage from '../pages/home/page';
import AboutPage from '../pages/about/page';
import ServicesPage from '../pages/services/page';
import BrandingVisualIdentityPage from '../pages/services/branding/page';
import BrandingPage from '../pages/services/branding/branding/page';
import LogoDesignPage from '../pages/services/branding/logo-design/page';
import PackagingDesignPage from '../pages/services/branding/packaging-design/page';
import CampaignIdentityPage from '../pages/services/branding/campaign-identity/page';
import GraphicMotionDesignPage from '../pages/services/branding/graphic-motion-design/page';
import MarketingPage from '../pages/services/marketing/page';
import AIPage from '../pages/services/ai/page';
import AISocialMediaPage from '../pages/services/ai-social-media/page';
import AIPPCPage from '../pages/services/ai-ppc/page';
import AIGoogleAdsPage from '../pages/services/ai-google-ads/page';
import ThreeDPage from '../pages/services/threed/page';
import Web3Page from '../pages/services/web3/page';
import NotFound from '../pages/NotFound';
import NewsPage from '../pages/news/page';
import CareersPage from '../pages/careers/page';
import ArticlesPage from '../pages/articles/page';
import ContactPage from '../pages/contact/page';

const DataAnalyticsPage = lazy(() => import('../pages/services/data-analytics/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />
  },
  {
    path: '/about',
    element: <AboutPage />
  },
  {
    path: '/services',
    element: <ServicesPage />
  },
  {
    path: '/services/branding',
    element: <BrandingVisualIdentityPage />
  },
  {
    path: '/services/branding/branding',
    element: <BrandingPage />
  },
  {
    path: '/services/branding/logo-design',
    element: <LogoDesignPage />
  },
  {
    path: '/services/branding/packaging-design',
    element: <PackagingDesignPage />
  },
  {
    path: '/services/branding/campaign-identity',
    element: <CampaignIdentityPage />
  },
  {
    path: '/services/branding/graphic-motion-design',
    element: <GraphicMotionDesignPage />
  },
  {
    path: '/services/marketing',
    element: <MarketingPage />
  },
  {
    path: '/services/ai',
    element: <AIPage />
  },
  {
    path: '/services/ai-social-media',
    element: <AISocialMediaPage />
  },
  {
    path: '/services/ai-ppc',
    element: <AIPPCPage />
  },
  {
    path: '/services/ai-google-ads',
    element: <AIGoogleAdsPage />
  },
  {
    path: '/services/threed',
    element: <ThreeDPage />
  },
  {
    path: '/services/web3',
    element: <Web3Page />
  },
  {
    path: '/services/data-analytics',
    element: <DataAnalyticsPage />
  },
  {
    path: '/news',
    element: <NewsPage />
  },
  {
    path: '/articles',
    element: <ArticlesPage />
  },
  {
    path: '/careers',
    element: <CareersPage />
  },
  {
    path: '/contact',
    element: <ContactPage />
  },
  {
    path: '*',
    element: <NotFound />
  }
];

export default routes;
